import { createFeature, createReducer, on } from "@ngrx/store";
import { DashboardStoreInterface } from "../../interfaces";
import { dashboardActions } from "./dashboard.action";

const initialState: DashboardStoreInterface = {
    adminDashboardSummary: null,
    adminDashboardActivities: null,
    adminFeesPaymentTrend: null,
    adminFeesByStd: null,
    adminAdmByStd: null,
};

const dashboardFeature = createFeature({
    name: "dashboard",
    reducer: createReducer(
        initialState,
        on(dashboardActions.setAdminDashboardSummary, (state, action) => ({
            ...state,
            adminDashboardSummary: action.data,
        })),
        on(dashboardActions.setAdminDashboardActivities, (state, action) => ({
            ...state,
            adminDashboardActivities: action.data,
        })),
        on(dashboardActions.setAdminFeesByStd, (state, action) => ({
            ...state,
            adminFeesByStd: action.data,
        })),
        on(dashboardActions.setAdminFeesPaymentTrend, (state, action) => ({
            ...state,
            adminFeesPaymentTrend: action.data,
        })),
        on(dashboardActions.setAdminAdmByStd, (state, action) => ({
            ...state,
            adminAdmByStd: action.data,
        })),
    ),
});

export const {
    name: dashboardFeatureKey,
    reducer: dashboardReducer,
    selectAdminDashboardSummary,
    selectAdminDashboardActivities,
    selectAdminFeesByStd,
    selectAdminFeesPaymentTrend,
    selectAdminAdmByStd,
} = dashboardFeature;
